import { useParams, usePathname } from 'next/navigation';

import useUser from '@/hooks/swr/useUser';
import useUserRole from '@/hooks/user/useUserRole';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

import { FREE_PLAN } from '@/types/pricingTypes/planType';

// Lib
import { pagesWithoutSubscription } from '@/lib/middleware/accessControl/pagesWithoutSubscription';

import { ACCOUNT, SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

export const useRequiresSubscription = () => {
    const { user } = useUser();
    const { subscription } = useSubscription();
    const { isAdmin } = useUserRole();

    const params = useParams();
    const pathname = usePathname();

    /**
     * Replace url parameters with the real value
     */
    const formattedUrl = formatUrls(pagesWithoutSubscription, params);

    /**
     * Check if the user has access to the page
     */
    const noAccess =
        !user?.subscribed_or_trial &&
        subscription?.product_key !== FREE_PLAN &&
        !formattedUrl.includes(pathname);
    const redirect_url = isAdmin ? SUBSCRIPTION_INVOICES : ACCOUNT;

    return { hasAccess: !noAccess, redirect_url };
};
